<template>
  <div>
    <navbar :links="['dashboard', $route.name]" />
    <v-layout justify-center>
      <!-- Search -->
      <v-text-field
        v-model="musicSearchText"
        class="searchbar-input"
        hide-details
        :label="musicSearchLabel"
        clearable
        append-icon="search"
        @keyup.native.esc="musicSearchText = ''"
      />
    </v-layout>
    <!-- Loading Indicator -->
    <div class="loading-indicator">
      <v-progress-circular
        v-if="loading"
        id="content-loading-indicator"
        :size="50"
        indeterminate
        class="progress--absolute-top mt-5 msr--text text--lighten-2"
      />
    </div>
    <div v-if="filteredRadioChannels.length > 0">
      <!-- Promoted Radio Channels -->
      <h2
        v-if="promotedRadioChannels.length > 0"
        class="ml-1 mt-4 mb-2 grey--text text--darken-1"
      >
        {{ $t('radioChannelsPromoted') }}
      </h2>
      <div
        v-if="
          promotedRadioChannels.length > 0 &&
            globalChannelConfig.message_for_highlighted_channels
        "
        class="ml-1 mr-4 mb-2 clickable"
        :class="{'message-collapsed': !messageForHighlightedChannelsExpanded}"
        :title="
          messageForHighlightedChannelsExpanded
            ? $t('clickToCollapse')
            : $t('clickToExpand')
        "
        @click="
          messageForHighlightedChannelsExpanded =
            !messageForHighlightedChannelsExpanded
        "
      >
        {{ globalChannelConfig.message_for_highlighted_channels }}
      </div>
      <div class="channel-grid">
        <radio-channel-card
          v-for="(channel, channelIndex) in promotedRadioChannels"
          :key="'promotedRadioChannel_' + channelIndex"
          :title="channel.name"
          :channel="channel"
          data-cy="radiochannel-card"
          @click.native="goToChannelDetail(channel)"
        />
      </div>
      <!-- Radio Channels -->
      <h2
        v-if="normalRadioChannels.length > 0"
        class="ml-1 mt-4 mb-2 grey--text text--darken-1"
        data-cy="radiochannels-header"
      >
        {{ $t('radioChannels') }}
      </h2>

      <div class="channel-grid">
        <radio-channel-card
          v-for="(channel, channelIndex) in normalRadioChannels"
          :key="'normalRadioChannel_' + channelIndex"
          :title="channel.name"
          :channel="channel"
          data-cy="radiochannel-card"
          @click.native="goToChannelDetail(channel)"
        />
      </div>
      <!-- Playlist Channels -->
      <h2
        v-if="playlistRadioChannels.length > 0"
        class="ml-1 mt-4 mb-2 grey--text text--darken-1"
      >
        {{ $t('playlistChannels') }}
      </h2>
      <div class="channel-grid">
        <radio-channel-card
          v-for="(channel, channelIndex) in playlistRadioChannels"
          :key="'playlistRadioChannel_' + channelIndex"
          :title="channel.name"
          :channel="channel"
          @click.native="goToChannelDetail(channel)"
        />
      </div>
    </div>
  </div>
</template>

<script>
import filter from 'lodash.filter';

import matchesFilter from '@/matchesFilter';

import Navbar from '@/components/Navbar';
import RadioChannelCard from '@/components/RadioChannelCard';

export default {
  components: {
    Navbar,
    RadioChannelCard,
  },
  data() {
    return {
      loading: false,
      musicSearchText: '',

      globalChannelConfig: {},
      messageForHighlightedChannelsExpanded: false,
    };
  },
  computed: {
    radioChannels() {
      return this.$store.state.common.radioChannels;
    },
    /**
     * Filter musicSearchText against each Campaign.
     */
    filteredRadioChannels() {
      const vm = this;

      if (vm.campaignsSearchText === null) {
        vm.campaignsSearchText = '';
      }

      return filter(this.radioChannels, (channel) => {
        const matchesSearch =
          matchesFilter(channel.name, vm.musicSearchText) ||
          matchesFilter(channel.description, vm.musicSearchText);
        return matchesSearch;
      });
    },
    musicSearchLabel() {
      return this.$t('search') + ` (${this.filteredRadioChannels.length}) ...`;
    },
    promotedRadioChannels() {
      return this.filteredRadioChannels.filter(
        (channel) => channel.is_new || channel.is_highlighted
      );
    },
    nonPromotedRadioChannels() {
      return this.filteredRadioChannels.filter(
        (channel) => !(channel.is_new || channel.is_highlighted)
      );
    },
    normalRadioChannels() {
      return this.nonPromotedRadioChannels.filter(
        (channel) => !channel.playlist_channel
      );
    },
    playlistRadioChannels() {
      return this.nonPromotedRadioChannels.filter(
        (channel) => channel.playlist_channel
      );
    },
  },
  mounted() {
    this.fetchGlobalChannelConfigMessage();
    this.fetchChannels();
  },
  methods: {
    fetchGlobalChannelConfigMessage() {
      this.$api.retrieveGlobalChannelConfig().then((response) => {
        this.globalChannelConfig = response.data;
      });
    },
    fetchChannels() {
      this.loading = true;
      this.$store.dispatch('LIST_RADIO_CHANNELS').then(() => {
        this.loading = false;
      });
    },
    goToChannelDetail(channel) {
      const path = `/channel/${channel.id}`;
      this.$router.push(path);
    },
  },
};
</script>

<style scoped>
/* lg, xl */
.channel-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(calc(33% - 48px), 0.33fr));
  gap: 36px;
}
/* md, sm */
@media (max-width: 1263px) {
  .channel-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 24px;
  }
}
/* lower than xs */
@media (max-width: 499px) {
  .channel-grid {
    grid-template-columns: 1fr;
    gap: 16px;
  }
}

.progress--absolute-top {
  position: absolute;
  z-index: 3;
  top: 60px;
}

.searchbar-input {
  max-width: 400px;
}

.message-collapsed {
  display: -webkit-box;
  overflow: hidden;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
</style>



// WEBPACK FOOTER //
// src/pages/Music.vue